<template>
  <CreateEditOrcamentoModal
    v-if="showCreateEditOrcamentoModal"
    :orcamentoId="orcamentoIdSelected"
    @closeModal="closeCreateEditOrcamentoModal"
  />
  <div class="mt-3 mb-2">
    <div class="row">
      <div class="col-8">
        <h2 class="fw-bold">
          <router-link
            to="/admin"
            class="text-teal"
            title="Área Administrativa"
          >
            Área Administrativa
          </router-link>
          <span class="text-gray">/ Orçamentos</span>
        </h2>
      </div>
      <div class="col-4 text-end">
        <button
          type="button"
          class="btn btn-success"
          title="Cadastrar Novo Período"
          @click="createEditOrcamento()"
        >
          Cadastrar Novo Período
        </button>
      </div>
    </div>
  </div>
  <LoadingData v-if="loadData" />
  <ListOrcamentos
    v-else
    :orcamentos="orcamentos"
    @editOrcamento="createEditOrcamento"
    @setActiveOrcamento="setActiveOrcamento"
  />
</template>

<script>
import CreateEditOrcamentoModal from '@/components/admin/orcamentos/CreateEditOrcamentoModal.vue'
import LoadingData from '@/components/commons/LoadingData.vue'
import ListOrcamentos from '@/components/admin/orcamentos/ListOrcamentos.vue'

export default {
  name: 'Orcamentos',

  components: {
    CreateEditOrcamentoModal,
    LoadingData,
    ListOrcamentos,
  },

  data() {
    return {
      loadData: true,
      showCreateEditOrcamentoModal: false,
      orcamentos: [],
      orcamentoIdSelected: null,
    }
  },

  methods: {
    async getOrcamentos() {
      try {
        this.orcamentos = await this.$store.dispatch('getOrcamentos')
        this.loadData = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    createEditOrcamento(orcamentoId) {
      this.orcamentoIdSelected = orcamentoId || null
      this.showCreateEditOrcamentoModal = true
    },

    async setActiveOrcamento(orcamentoId) {
      try {
        const response = await this.$store.dispatch(
          'activeOrcamento',
          orcamentoId,
        )
        this.getOrcamentos()
        this.$root.$refs.notification.success(response.message)
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    closeCreateEditOrcamentoModal(loadListOrcamentos) {
      if (loadListOrcamentos) {
        this.getOrcamentos()
      }
      this.showCreateEditOrcamentoModal = false
    },
  },

  mounted() {
    this.getOrcamentos()
  },
}
</script>
